import { useState, useEffect } from "react";
import { getDivision } from "../services/divisionService";
import { useNavContext } from "../context/nav_context";

const useDivision = (divisionId) => {
  const { accessToken } = useNavContext();
  const [division, setDivision] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!divisionId) return;

    let cancelled = false;

    const loadDivision = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await getDivision(divisionId, accessToken);
        if (!cancelled) {
          setDivision(data);
        }
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadDivision();

    return () => {
      cancelled = true;
    };
  }, [divisionId, accessToken]);

  return { division, loading, error };
};

export default useDivision;
